import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ExpenseTripFormComponent } from '../expense-trip-form/expense-trip-form.component';
import { AdvanceExpenseFormComponent } from '../advance-expense-form/advance-expense-form.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';

@Component({
  selector: 'app-advance-expense',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, LoaderComponent, FormsModule,NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './advance-expense.component.html',
  styleUrl: './advance-expense.component.scss'
})
export class AdvanceExpenseComponent {
  isDisabled: boolean = false;
  Filter = {
    ApprovalStatus:'All',
    TripId:null,
    SelectType: 1,
    ESS_ExpenseAdvanceRequestId: 0,
    EmpMasterId:null,
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
  }

  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private dateFormat: CustomDateParserFormatter,
    private utility: UtilityService,
  ) {
    this.common.getPageRights();
    this.Filter.EmpMasterId = this.session.GetUserDetails().UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExpenseAdvanceRequest_SelectUpdate() {
    this.isDisabled = true;
    this.TableDatas = Object.values([]);
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.expense.ESS_ExpenseAdvanceRequest_SelectUpdate(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);   
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTrip() {
    const modalRef = this.modalService.open(ExpenseTripFormComponent, { backdrop: 'static', });
    modalRef.result.then(
      (result: any) => { },
      () => { }
    );
  }

  addAdvanceExpenses() {
    const modalRef = this.modalService.open(AdvanceExpenseFormComponent, { backdrop: 'static', });
    modalRef.result.then(
      (result: any) => {
        if (result != undefined && result) {
          this.TableDatas = Object.values([]);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });

          this.ESS_ExpenseAdvanceRequest_SelectUpdate();
        }
      },
      () => { }
    );
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.common.ToLowerCase(this.Filter.ApprovalStatus) == 'pending' || (this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'pending' && (moment(this.dateFormat.format(this.Filter.ToDateObj),'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj),'DD MMM YYYY'))))) {
        this.ESS_ExpenseAdvanceRequest_SelectUpdate();
      }
    }
    else {
      form.submitted = true;
    }
  }

  ClearData(){
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ESS_ExpenseAdvanceRequest_SelectUpdate();
      },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }
}
